export const entrances = [
  {
    id: 'e-01',
    icon: 'ri-fire-line',
    name: '塌房条线',
    desc: '感情线与立场争议的完整时间轴',
    count: 148,
  },
  {
    id: 'e-02',
    icon: 'ri-alarm-warning-line',
    name: '翻车现场',
    desc: '舞台、直播与公开场合的事故记录',
    count: 132,
  },
  {
    id: 'e-03',
    icon: 'ri-scales-3-line',
    name: '争议焦点',
    desc: '一次把双方说法并列摆好',
    count: 205,
  },
  {
    id: 'e-04',
    icon: 'ri-file-warning-line',
    name: '丑闻档案',
    desc: '早期记录与旧动态的原文留存',
    count: 96,
  },
  {
    id: 'e-05',
    icon: 'ri-music-2-line',
    name: '作品重合',
    desc: '旋律、分镜与文案的比对结果',
    count: 61,
  },
  {
    id: 'e-06',
    icon: 'ri-contract-line',
    name: '合作合约',
    desc: '解约、换角与排期冲突的落点',
    count: 83,
  },
  {
    id: 'e-07',
    icon: 'ri-shield-check-line',
    name: '避雷清单',
    desc: '按状态筛出可直接参考的条目',
    count: 264,
  },
  {
    id: 'e-08',
    icon: 'ri-time-line',
    name: '结果汇总',
    desc: '已经出结果的条线集中在这里',
    count: 96,
  },
];